import RadioList from './RadioList';
import TextArea from './TextArea';
import TextBox from './TextBox';
import YesNo from './YesNo';
import DecimalInput from './DecimalInput';
import NumberInput from './NumberInput';
import DropDownList from './DropDownList';
import CheckboxList from './CheckboxList';

export default {
  radioButton: RadioList,
  textArea: TextArea,
  textBox: TextBox,
  yesNo: YesNo,
  decimal: DecimalInput,
  integer: NumberInput,
  dropDownList: DropDownList,
  checkBox: CheckboxList,
};



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/index.js